export default __webpack_public_path__ + "static/media/if-you-are-2.64ed2bc0.svg";